<template>
  <v-layout wrap>
    <v-flex sm12>
      <v-toolbar dense ref="aToolbar" flat>
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left-bold-outline</v-icon>
        </v-btn>
        <v-toolbar-title>
          {{ $t('MASSEDIT_TITLE') }}
          <span class="subheading">({{ $t('MASSEDIT_NUMBER_INCLUDED', [numSelected]) }})</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items >
          <!-- <v-btn text color="black" :disabled="!mItems.length" @click="onSaveTemplate()">{{ $t('MASSEDIT_SAVE_TEMPLATE') }}</v-btn> -->
          <!-- <v-btn text color="black" :disabled="!mItems.length" @click="onSaveAsTemplate()">{{ $t('MASSEDIT_SAVE_AS_TEMPLATE') }}</v-btn> -->
          <!-- {{ mItems.length }} -->
          <v-btn text @click="onSave()" :disabled="!massEditConfiguration"><v-icon>mdi-floppy</v-icon> {{ $t('GENERIC_SAVE') }}</v-btn>
          <v-btn text @click="nameDlg=true" ><v-icon>mdi-rename-box</v-icon> {{ $t('GENERIC_SAVEAS') }}</v-btn>
          <v-btn text @click="onDelete()" :disabled="!massEditConfiguration" color="red darken-1"><v-icon>mdi-trash-can</v-icon> {{ $t('GENERIC_DELETE') }}</v-btn>
          <v-btn text color="primary" :disabled="!mItems.length" @click="onExecute()">{{ $t('MASSEDIT_RUN') }}</v-btn>
<v-btn v-if="isDebug" fab small color="grey lighten-3" class="btn-debug" @click="debug=!debug"><v-icon>mdi-bug-outline</v-icon></v-btn>
        </v-toolbar-items>
      </v-toolbar>
    </v-flex>
    <v-flex sm12 v-if="debug">
{{ ids }}
<v-divider />
<!-- {{ selectedContacts }} -->
    </v-flex>
    <v-flex sm12>

      <v-container>
        <v-card>
          <v-flex xs12>
            <v-select
              v-model="massEditConfiguration"
              :items="massEditConfigurationItems"
              :label="$t('EXPORT_SELECT_CONFIG')"
              item-text="name"
              item-value="id"
              return-object
              clearable
            ></v-select>
          </v-flex>
          <!-- <v-flex xs12>
            <v-alert type="error" dismissible :value="showAlert">
              {{alertText}}
            </v-alert>
          </v-flex> -->
        </v-card> 

        <v-card>
          <v-card-text>

      <v-layout>
        <v-flex>
          <!-- {{mItems}} -->
          <!-- {{ commands }} -->
          <ContactMassEditItem
            v-for="(item, idx) in mItems"
            :key="idx"
            :idx="idx"
            :meItem="item"
            :hasAdd="idx==mItems.length-1"
            @add="addItem()"
            @remove="removeItem(idx)"
            :debug="debug"
            :fields="fields"
            :commands="def_commands"
          />

        </v-flex>
      </v-layout>

          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-container>

    </v-flex>

    <v-dialog v-model="nameDlg" persistent max-width="500">
      <v-card>
        <v-card-title class="headline">{{$t('EXPORT_SAVEAS_HEADER')}}</v-card-title>
        <v-card-text>
          <v-text-field
              v-model="exportName"
              :label="$t('SAVEAS_DIALOG_NAME')"
              :rules2="[value => value.length <= 50 || 'Max 50 characters']"
          ></v-text-field>
          <v-alert type="warning" dismissible :value="nameAlert">
            {{nameTextAlert}}
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="nameDlg=false;onSaveAs()" :disabled="!exportName || nameAlert">{{$t('SAVEAS_DIALOG_SAVE')}}</v-btn>
          <v-btn color="green darken-1" text @click="nameDlg=false">{{$t('SAVEAS_DIALOG_CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
// import Contact from "../services/Contact";
import ContactMassEditItem from './ContactMassEditItem'
import { MassEditItemModel } from '../models/MassEditItemModel'
import { json2xml } from 'xml-js';
import APISelection from './../services/Selection'
import Search from '../services/Search';
import MassEditConfig from '../services/MassEditConfig'

export default {
  name: 'ContactMassEdit',
  components: {
    ContactMassEditItem,
  },
  props: ['refToolbar'],
  data() {
    return {
      debug: false,
      mItems: [],
      massEditConfiguration: null,
      def_commands: require('../config/commands.json'),
      exportName: null,
      nameDlg: false,
      showAlert: false,
      alertText: '',
      itemToReload: null
    }
  },
  computed: {
    ...mapGetters(['isDebug', 'exportIds', 'allToExport', 'contactsTotal', 'searchReq', 'massEditConfigurationItems','data']),
    numSelected() {
      return this.allToExport ? this.contactsTotal - this.exportIds.length : this.exportIds.length
    },
    fields() {
      let fields = [], _fields

      _fields = this.data.fields.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
      if (_fields.length) {
      //   fields.push({ header: '' })
        fields.push(..._fields
          .map(a => ({ ...a, value: `i${a.value}`, label: this.$t(a.text) }))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
      }

      _fields = this.data.categories.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
      if (_fields.length) {
        fields.push({ header: this.$t('CONTACT_CATEGORIES') })
        fields.push(..._fields
          .map(a => ({ ...a, value: `c${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
      }

      _fields = this.data.custom_fields.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
      if (_fields.length) {
        fields.push({ header: this.$t('CONTACT_FREE_FIELDS') })
        fields.push(..._fields
          .map(a => ({ ...a, value: `f${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
      }

      _fields = this.data.additional_fields.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
      if (_fields.length) {
        fields.push({ header: this.$t('EXTSEARCH_NOTES_SEPARATOR') })
        fields.push(..._fields
          .map(a => ({ ...a, value: `a${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
      }

      return fields
    },
    nameAlert() {
      return (!this.mItems.length || this.mItems.map( item => item.name ).includes(this.exportName))
    },
    nameTextAlert() {
      if (!this.mItems.length) {
        return this.$t('EXPORT_INVALID_NOFIELDS')
      } else if (this.mItems.map( item => item.name ).includes(this.exportName)) {
        return this.$t('SAVEAS_DIALOG_NAME_EXISTS')
      } else {
        return ''
      }
    }
  },

  watch: {
    massEditConfiguration(val) {
// console.log('exportConfiguration', val)
      if (val) {
        this.exportName = val.name
        new MassEditConfig(this.$api).load(val.id)
          .then(res => {
            let items = res.mass_edit_config && res.mass_edit_config.request && res.mass_edit_config.request.items 
            items = Array.isArray(items) && items || [items]
//       console.log(items);
//       console.log(this.def_commands);
            this.mItems = items.map(item => {
              const newItem = new MassEditItemModel()
              var tmp = this.fields.filter(c => c.id == item.field._attributes.id)
              if (item.field._attributes.type) {
                 newItem.field = tmp.filter(c => c.type == item.field._attributes.type)[0]
                 newItem.command = this.def_commands[this.fields.find(f=>f.id == item.field._attributes.id && f.type == item.field._attributes.type)['datatype']].find(c=>c.id == item.command._attributes.id)
              } else {
                 newItem.field = tmp[0]
                 newItem.command = this.def_commands[this.fields.find(f=>f.id == item.field._attributes.id )['datatype']].find(c=>c.id == item.command._attributes.id)
              }
//       console.log(newItem);
              newItem.value = item.value && item.value._text
              return newItem
            })
          })
      } 
    },
    massEditConfigurationItems() {
      if (this.itemToReload) {
        // TODO: fixit !!!
        // this.massEditConfiguration = this.massEditConfigurationItems.filter(item => item.id == this.itemToReload._attributes.id)[0]
        // this.itemToReload = null
      }
    }
  },

  mounted() {
    this.refToolbar.$el.parentElement.appendChild(this.$refs.aToolbar.$el)
    this.mItems.push(new MassEditItemModel())
    new MassEditConfig(this.$api).list()
  },

  methods: {
    addItem() {
      this.mItems.push(new MassEditItemModel())
    },
    removeItem(idx) {
      idx > -1 && this.mItems.splice(idx, 1)
      if (!this.mItems.length) {
        this.addItem()
      }
    },
    onExecute() {
      const xml = this.buildXML()
      // console.log(xml);return;
      new APISelection(this.$api).set(xml)
        .then(() => {
          this.$router.go(-1)
        })
    },
    onSave() {
       console.log(this.mItems);
       new MassEditConfig(this.$api).create(this.massEditConfiguration && this.massEditConfiguration.id, this.exportName, this.mItems)
    },
    onSaveAs() {
       new MassEditConfig(this.$api).create(null, this.exportName , this.mItems)
       .then(res => {
          this.itemToReload = res
       })
    },
    onDelete() {
      new MassEditConfig(this.$api).delete(this.massEditConfiguration.id)
    },  
    // commands(meneItem) {
    //   const field = this.fields.filter(f => f.id == meneItem.field._attributes.id)[0]
    //   let commands = []
    //   const datatype = field ? field.datatype : 'default'
    //   commands = this.def_commands[datatype] && Array.isArray(this.def_commands[datatype])
    //     ? this.def_commands[datatype].filter(a => a.id.indexOf('_') !== 0 && (a.id !== 'del' || field.multiple === '1')) : []
    //   commands = commands.map(a => ({ ...a, label: this.$t(a.text) }))

    //   return commands.filter(c => c.id == meneItem.command._attributes.id)[0]
    // },
    buildXML() {
      const s_query = new Search(this.$api).buildSearchBlockToJS()
console.log('s_query', s_query)

      // Flags - deselect - no_account
      // API: Selection:set
/*
      xml = `
<request>
  <selection type="list">
    <include>
      <aitem id="38269"/>
    </include>
  </selection>
  <set>
    <fields/>
    <categories>
      <cat id="10" event="del" catid="560"/>
    </categories>
    <freefields/>
  </set>
</request>
`
*/
      const jsonObject = {
        request: {
          selection: {
            _attributes: {
              type: this.searchReq.type,
            },
            // include: {
            //   aitem: [
            //     // {
            //     //   _attributes: {
            //     //     id: '38269'
            //     //   }
            //     // }
            //   ]
            // }
          },
          set: {
            fields: {

            },
            categories: {
              cat: [
                // {
                //   _attributes: {
                //     id: '10',
                //     event: 'del',
                //     catid: '560'
                //   }
                // }
              ]
            },
            freefields: {
              ff: [
                // {
                //   _attributes: {
                //   }
                // }
              ]
            }
          }
        }
      }
      // this.selectedContacts.forEach(a => {
      //   jsonObject.request.selection.include.aitem.push({
      //     _attributes: {
      //       id: a.id
      //     }
      //   })
      // });
      if (this.allToExport) { // exclusive
        jsonObject.request.selection._attributes = {
          'type': this.searchReq.type
        }
        if (this.searchReq.val == 'new' || this.searchReq.val == 'all') {
          jsonObject.request.selection.query = s_query
        } else {
          if (this.searchReq.type !== 'simple') {
            jsonObject.request.selection.query = {
              _attributes: {
                id: this.searchReq.val
              }
            }
          }
        }
        jsonObject.request.selection.exclude = {
          aitem: [
            // {
            //   _attributes: {
            //     id: '41341'
            //   }
            // }
          ]
        }
        if (this.exportIds.length) {
          this.exportIds.forEach(a => {
            jsonObject.request.selection.exclude.aitem.push({
              _attributes: {
                id: a
              }
            })
          });
        } else {
          jsonObject.request.selection._attributes.search_string = this.searchReq.val
        }
      } else { // inclusive
        jsonObject.request.selection._attributes = {
          'type': 'list'
        }
        jsonObject.request.selection.include = {
          aitem: [
            // {
            //   _attributes: {
            //     id: '41341'
            //   }
            // }
          ]
        }
        if (this.exportIds.length) {
          this.exportIds.forEach(a => {
            jsonObject.request.selection.include.aitem.push({
              _attributes: {
                id: a
              }
            })
          });
        }
      }
      this.mItems.forEach(a => {
        if (a.field) {
          if (a.field.type == 'field') {
            jsonObject.request.set.fields[a.field.id] = a.command.id != 'clear'
              ? (a.field.datatype === 'checkbox'
                ? (a.command.id === 'select' ? 1 : +a.value)
                : a.value)
              : ''
          }
          if (a.field.type == 'catlist') {
            jsonObject.request.set.categories.cat.push({
              _attributes: {
                id: a.field.id,
                event: a.command.id === 'clear' ? 'del' : a.command.id,
                catid: a.command.id != 'clear' ? a.value : ''
              }
            })
          }
          if (a.field.type == 'free') {
            jsonObject.request.set.freefields.ff.push({
              _attributes: {
                id: a.field.id
              },
              _text: a.command.id != 'clear' ? a.value : ''
            })
          }
        }
      });
      return json2xml(jsonObject, {compact: true})
    }
  },

  beforeDestroy() {
    this.$refs.aToolbar.$el.remove()
  },
}
</script>

<style>

</style>
